export default __webpack_public_path__ + "static/media/noPhoto.0a73443f.jpg";